import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SceneViewer } from '../SceneViewer/SceneViewer';

import './SceneViewerContainer.css';
import { Config } from '../Config';
import { store } from '../Store';
import { reaction } from 'mobx';

class SceneViewerContainer extends Component {
  constructor(props) {
    super(props);

    this.sceneViewer = null;
  }

  async componentDidMount() {
    this.sceneViewer = new SceneViewer({
      canvas: this.canvas
    });

    await this.sceneViewer.load();
    
    if (Config.AUTOSTART) {
      this.sceneViewer.start();
    } else {
      reaction(() => store.started, async (value, prevValue) => {
        if (value && !prevValue) {
          this.sceneViewer.start();
        }
      });
    }
  }

  componentDidUpdate(prevProps) {

  }

  componentWillUnmount() {
    this.sceneViewer.dispose();
  }

  render() {
    return (
      <>
        <canvas ref={ref => (this.canvas = ref) } />
      </>
    )
  }
}

SceneViewerContainer.propTypes = {
  started: PropTypes.bool,
  paused: PropTypes.bool
};

export default SceneViewerContainer;